// Pure helpers for the /{assetClass}/ URL segment. No store, router or storage access, so it can be
// imported from anywhere (including modules evaluated before the app boots).

// Slugs the frontend knows how to put in a URL. Authorization is a separate question, answered by
// user/info: a known but unauthorized slug is still recognized here so it can be told apart from a
// path that simply is not an asset-class prefix.
export const KNOWN_ASSET_CLASSES = ['ibips', 'investment-certificates']

// Links that predate the asset classes (bookmarks, old emails) all pointed at IBIPs products.
export const LEGACY_ASSET_CLASS = 'ibips'

// BASE_URL without its trailing slash: '' for a root deployment, '/sub' otherwise.
function baseUrl() {
  return (process.env.BASE_URL || '/').replace(/\/+$/, '')
}

// The part of a browser pathname that follows the deployment base.
function pathWithoutBase(pathname) {
  const base = baseUrl()
  return base && pathname.startsWith(base) ? pathname.slice(base.length) || '/' : pathname
}

// The asset-class slug leading the pathname, or null when the first segment is not a known slug.
export function slugFromPath(pathname) {
  if (typeof pathname !== 'string') {
    return null
  }
  const first = pathWithoutBase(pathname).split('/')[1]
  return KNOWN_ASSET_CLASSES.includes(first) ? first : null
}

// The pathname without its leading asset-class segment (the route-relative path).
export function stripSlugFromPath(pathname) {
  const path = pathWithoutBase(pathname)
  return slugFromPath(pathname) ? '/' + path.split('/').slice(2).join('/') : path
}

// vue-router `base` for the given asset class: every href the router generates then carries the
// prefix by itself, while the route table stays flat.
export function routerBaseFor(slug) {
  return slug ? `${baseUrl()}/${slug}/` : process.env.BASE_URL || '/'
}

// Browser URL (without query/hash) of a route-relative path under the given asset class.
export function buildAssetClassUrl(slug, routePath) {
  return `${baseUrl()}/${slug}${routePath || '/'}`
}
